import React from 'react'

function Addnumbers() {
  return (
    <div>Addnumbers</div>
  )
}

export default Addnumbers